import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function BalanceHistoryByPlayer() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Balance History By Player Report"
        getUrl={() => "/Reports/Report_Balance_History_ByPlayer"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Player: player,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            thisWeek:
              item.day1 +
              item.day2 +
              item.day3 +
              item.day4 +
              item.day5 +
              item.day6 +
              item.day7,
          }))
        }
        getTotals={(data) => ({
          startDate: "Totals",
          lifeTime: data.reduce((acc, item) => acc + item.lifeTime, 0),
          balFwd: data.reduce((acc, item) => acc + item.balFwd, 0),
          lastWeek: data.reduce((acc, item) => acc + item.lastWeek, 0),
          day1: data.reduce((acc, item) => acc + item.day1, 0),
          day2: data.reduce((acc, item) => acc + item.day2, 0),
          day3: data.reduce((acc, item) => acc + item.day3, 0),
          day4: data.reduce((acc, item) => acc + item.day4, 0),
          day5: data.reduce((acc, item) => acc + item.day5, 0),
          day6: data.reduce((acc, item) => acc + item.day6, 0),
          day7: data.reduce((acc, item) => acc + item.day7, 0),
          thisWeek: data.reduce((acc, item) => acc + item.thisWeek, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="startDate"
          dataFormat={dateReportFormatter}
        >
          Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lifeTime"
          dataFormat={decimalInvertedReportFormatter}
        >
          LifeTime
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          Last Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="balFwd"
          dataFormat={decimalInvertedReportFormatter}
        >
          BOW
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day1"
          dataFormat={decimalInvertedReportFormatter}
        >
          Mon
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Tue
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day3"
          dataFormat={decimalInvertedReportFormatter}
        >
          Wed
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day4"
          dataFormat={decimalInvertedReportFormatter}
        >
          Thu
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day5"
          dataFormat={decimalInvertedReportFormatter}
        >
          Fri
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day6"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sat
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day7"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sun
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="thisWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          This Week
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default BalanceHistoryByPlayer;
